import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Profiles = () => {
  const { id } = useParams(); // Get _id from URL
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch data using the environment variable for the base URL
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/members/${id}`, {
          method: "GET",
          headers: {
            'api-key': process.env.REACT_APP_API_KEY,
          }
        });
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const result = await response.json();
        setData(result);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error) return <div className="text-center text-red-600 mt-10">{error}</div>;
  const {
    image,
    first_name,
    sur_name,
    title,
    join_date,
    phone,
    email,
    gender,
    vaaar_id,
    dob,
    adhaar_id,
    createdAt,
    updatedAt,
    address,
    
  } = data;
  return (
    <div className="min-h-screen  flex items-center justify-center">
      <div className=" w-full p-8 text-center">
        {/* Profile Header */}
        <div className="flex flex-col items-center mb-8">
          <img
            src={image}
            alt={first_name}
            className="w-32 h-32 rounded-full object-cover border-4 border-indigo-500 shadow-md"
          />
          <h1 className="text-3xl font-bold text-gray-800 mt-4">{first_name} {sur_name}</h1>
          <p className="text-lg text-gray-600 italic">{title}</p>
          <p className="text-sm text-gray-500">Joined: {new Date(join_date).toLocaleDateString()}</p>
        </div>

        {/* Profile Profiles */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-4 bg-blue-50 rounded-lg shadow-sm">
            <p className="text-sm font-semibold text-gray-700">Phone:</p>
            <p className="text-blue-800 font-medium">{phone}</p>
          </div>
          <div className="p-4 bg-purple-50 rounded-lg shadow-sm">
            <p className="text-sm font-semibold text-gray-700">Email:</p>
            <p className="text-purple-800 font-medium">{email}</p>
          </div>
          <div className="p-4 bg-green-50 rounded-lg shadow-sm">
            <p className="text-sm font-semibold text-gray-700">Gender:</p>
            <p className="text-green-800 font-medium">{gender}</p>
          </div>
          <div className="p-4 bg-yellow-50 rounded-lg shadow-sm">
            <p className="text-sm font-semibold text-gray-700">Vaaar ID:</p>
            <p className="text-yellow-800 font-medium">{vaaar_id}</p>
          </div>
          <div className="p-4 bg-pink-50 rounded-lg shadow-sm">
            <p className="text-sm font-semibold text-gray-700">Date of Birth:</p>
            <p className="text-pink-800 font-medium">{new Date(dob).toLocaleDateString()}</p>
          </div>
          <div className="p-4 bg-indigo-50 rounded-lg shadow-sm">
            <p className="text-sm font-semibold text-gray-700">Aadhaar Number:</p>
            <p className="text-indigo-800 font-medium">{adhaar_id}</p>
          </div>
          <div className="p-4 bg-red-50 rounded-lg shadow-sm">
            <p className="text-sm font-semibold text-gray-700">Created At:</p>
            <p className="text-red-800 font-medium">{new Date(createdAt).toLocaleDateString()}</p>
          </div>
          <div className="p-4 bg-teal-50 rounded-lg shadow-sm">
            <p className="text-sm font-semibold text-gray-700">Updated At:</p>
            <p className="text-teal-800 font-medium">{new Date(updatedAt).toLocaleDateString()}</p>
          </div>
        </div>
        <div className="grid grid-cols-1 mt-6 ">
        <div className="p-4 bg-yellow-50 rounded-lg shadow-sm">
        <p className="text-sm font-semibold text-gray-700">Address:</p>
        <p className="text-teal-800 font-medium">{address}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profiles;
